import PropTypes from 'prop-types';
import React from 'react';

import ToggleButton from './ToggleButton';

const WildlifeThreatFilterCell = ({enabled, threatLevelName, speciesCount, onToggle}) => {

  return (
    <div className="WildlifeThreatFilterCell">

      <ToggleButton
        enabled={enabled}
        onClick={onToggle}
      />

      <p className="WildlifeThreatFilterCell__title">
        {threatLevelName}
      </p>

      <p className="WildlifeThreatFilterCell__speciesCount">
        {`${speciesCount} sp.`}
      </p>

    </div>
  );
};

WildlifeThreatFilterCell.propTypes = {
  enabled: PropTypes.bool.isRequired,
  threatLevelName: PropTypes.string.isRequired,
  speciesCount: PropTypes.number.isRequired,
};

export default WildlifeThreatFilterCell;



// WEBPACK FOOTER //
// ./src/components/WildlifeThreatFilterCell.js